export default __webpack_public_path__ + "static/media/statistics.e6a4072e.png";